import { Theme } from '@/utils/constants';
import { replaceLinks } from '@/utils/helpers';
import { BrPageContext } from '@bloomreach/react-sdk';
import clsx from 'clsx';
import React, { memo, useContext, useMemo } from 'react';
import CaptureClicks from '../CaptureClicks';
import { RichTextProps } from './RichText.interface';
import useStyles from './RichText.styles';

const RichText = ({
  theme = Theme.light,
  customStyles = false,
  content,
  className: overrideClassName,
  resolveLinks = true,
  'data-testid': dataTestId,
}: RichTextProps) => {
  const page = useContext(BrPageContext);
  const classes = useStyles({});

  const parsedContent = useMemo(() => {
    if (content && resolveLinks) {
      return replaceLinks({ content, page });
    }

    return content;
  }, [content, page, resolveLinks]);

  const className = clsx(
    'rich-text',
    classes.root,
    !customStyles && classes.default,
    `${theme}-theme`,
    overrideClassName,
  );

  return (
    <div
      className={className}
      data-testid={dataTestId}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: parsedContent || '' }}
    />
  );
};

export const CaptureClicksRichText = CaptureClicks(RichText);

export default memo(RichText);
